export default __webpack_public_path__ + "static/media/TableView.623d87c9.svg";